import TableQuoteOrders from '../../../../../../../../specificComponents/QuoteOrders'
import { getUserPermissions } from '../../../../../../../../utils/reducers/getters'
import { ModalFullCentered, CloseLateralModalSimple } from '../../../../../../../Modal'
import { ModalEditComponentProps } from '../../../../../../../ModalsLayouts/types'


interface QuoteOrdersListingModalProps extends ModalEditComponentProps {}

const QuoteOrdersListingModal: React.FC<QuoteOrdersListingModalProps> = ({...rest}) => {
    return (
        <ModalFullCentered opened={true} setOpened={() => rest.setOpened(null)} className='shortcut_modal'>
            <CloseLateralModalSimple onClose={() => rest.setOpened(null)} />
            <TableQuoteOrders setTableInstance={() => { }} userPermissions={getUserPermissions('quote.order') || { n: 1, permission: 'read' }} tableInstance={null} {...rest} setOpened={() => rest.setOpened(null)} onRowClick={() => rest.setOpened(null)}/>
        </ModalFullCentered>
    )
}

export default QuoteOrdersListingModal